var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"tile":"","elevation":"0"}},[(_vm.service)?_c('v-card-title',{staticClass:"pb-0 pt-0"},[_vm._v(" "+_vm._s(_vm.service)+" "),_c('v-spacer')],1):_vm._e(),(_vm.is_show_percentbar)?_c('v-card-text',[_c('span',{staticClass:"text-subtitle-1"},[_vm._v(" "+_vm._s(`${_vm.usage} / ${_vm.limit} (${_vm.safePercentage}%已使用)`)+" ")]),_c('v-progress-linear',{style:({
        width: '100%',
        borderRadius: '3px',
      }),attrs:{"value":_vm.safePercentage,"color":_vm.color,"height":"10"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }